// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"370":"c8d8252b","576":"a0283d14","714":"c032b72e"}[chunkId] + ".chunk.css";
};